import { SearchObject } from "app/common/Model/SearchObject";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

import {
  PAGESIZE_ALL,
  PAYMENT_METHOD_CHARACTERISTIC,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  TYPE_CARD,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { getCurrentStaff } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { getInvoiceItemByType } from "app/services/InvoiceItemService";
import { invoiceGenerateQRCode } from "app/services/InvoiceService";
import { pagingObj } from "app/services/PatientMethod";
import {
  getTotalUsedDeposit,
  initAdvanceMoneyTransaction,
  initPrepaidCardTransaction,
} from "app/services/PatientTransaction";
import { pagingTreatmentPlanCard } from "app/services/TreatmentPlanCardService";
import {
  cancelVoucherAndUpdateInvoice,
  createPaymentVoucherWithListMethod,
  createReceiveVoucherWithListMethod,
  createVoucherAndUpdateToCrm,
  getDetailById,
  getVoucherById,
  pageVoucherTotalCategory,
  receiveAdvancePayment,
  updateVoucher,
} from "app/services/VoucherService";

const DEFAULT_SEARCH_VOUCHER_FEE = {
  ...new SearchObject(),
  patientId: null,
  fromDate: new Date(),
  toDate: new Date(),
};

const DEFAULT_CARD_FEE = {
  department: null,
  accountant: null,
  invoiceItems: [],
};

const DEFAULT_DEPOSIT_MONEY_FEE = {
  department: null,
  accountant: null,
  invoiceItems: [],
};
export default class VoucherListStore {
  searchVoucherFee = {
    ...DEFAULT_SEARCH_VOUCHER_FEE,
  };
  searchFeeCard = {
    ...new SearchObject(),
    type: TYPE_CARD[0].value,
    isAvailable: true,
    pageSize: 50,
  };
  initialValueCardFee = {
    ...DEFAULT_CARD_FEE,
  };
  initialValueDepositMoneyFee = {
    ...DEFAULT_DEPOSIT_MONEY_FEE,
  };
  pageFeeCard = new PageResponse();
  openConfirmDelete = null;
  openConfirmMessage = null;
  openInvoicePopup = false;
  openPopupPrint = false;
  openVoucherPopupDetail = false;
  openStaffRevenueUpdate = false;
  openDepositPopup = false;
  openConfirmError = null;
  openClientCardFeePopup = false;
  openDepositMoneyFeePopup = false;

  dataVoucherFee = [];
  listStk = [];
  listPos = [];
  listPos_tragop = [];
  listHomecredit = [];
  listPaymentMethod = [];
  dataInvoicePopupFee = null;
  dataVoucherPopupFee = null;
  editableVoucher = false;
  initialDeposit = null;
  listServiceFromFeePopupSelected = []; //lay từ form fee popup
  listSelectedSv = [];
  listSelectedCard = [];
  selectedFee = null;
  openPaymentVoucherPopup = false;
  openTemporaryInvoicePrintPopup = false;
  initialPaymentVoucher = null;
  initialReceiptVoucher = null;

  openReceiptVoucherPopup = false;

  printData = null;
  constructor() {
    makeAutoObservable(this);
  }

  handleFeePopupPrint = (row) => {
    this.selectedFee = row;
  };

  setOpenTemporaryInvoicePrintPopup = (state) => {
    this.openTemporaryInvoicePrintPopup = state;
  };
  setPrintData = async (values) => {
    const allItems = [
      ...(values?.services?.items || []),
      ...(values?.products?.items || []),
      ...(values?.prepaidCards?.items || []),
      ...(values?.treatmentCards?.items || []),
    ];
    const data = allItems?.filter((item) => item?.checked);
    let paymentBank = values?.voucherPaymentMethods?.find(
      (el) =>
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC[0].value
    )?.paymentBank;
    let QRCode = {};
    if (paymentBank) {
      let newSearchObj = {
        amount: values?.moneyAfterDiscount,
        content: "CK",
        acquierId: paymentBank?.propertyValue,
        consumerId: paymentBank?.property,
      };

      QRCode.qrBankCode = await invoiceGenerateQRCode(newSearchObj)
        .then(({ data }) => {
          const base64String = btoa(
            new Uint8Array(data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          return `data:image/jpeg;base64,${base64String}`;
        })
        .catch((error) => {
          toast.error("Lấy QR thất bại");
        });
    }
    this.printData = {
      items: data,
      QRCode,
    };
  };

  getDataDetailVoucher = async (voucher) => {
    const voucherId = voucher?.id;
    this.editableVoucher = false;
    if (!voucherId) {
      return;
    }
    return await getVoucherById(voucherId)
      .then(({ data }) => {
        this.dataVoucherPopupFee = data;
        this.openVoucherPopupDetail = true;
      })
      .catch(({ error }) => {
        toast.error("Lấy chi tiết phiếu thu có lỗi");
      });
  };

  getDataVoucherTotalCategory = async () => {
    let { departmentId, ...ortherData } = this.searchVoucherFee;

    // Không call API nếu không có cơ sở (bắt buộc) VÀ không có patientId
    // Nếu có patientId (xem thông tin khách hàng) thì không cần bắt buộc cơ sở
    if (!departmentId && !this.searchVoucherFee.patientId) {
      this.dataVoucherFee = [];
      return;
    }

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await pageVoucherTotalCategory({ ...ortherData })
      .then(({ data }) => {
        this.dataVoucherFee = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hóa đơn có lỗi");
      });
  };

  handleChangeFormSearch = (search) => {
    this.searchVoucherFee = { ...this.searchVoucherFee, ...search };
    this.getDataVoucherTotalCategory();
  };
  setListSelectedSv = (list) => {
    this.listSelectedSv = list;
  };
  setListSelectedCard = (list) => {
    this.listSelectedCard = list;
  };

  handleCalculateRemaining = (el) => {
    let beforeTax;
    let tax;
    let aftefTax;
    if (el?.priceWithTax) {
      aftefTax = el?.currentFee * el?.quantity - el?.discount;
      tax =
        (aftefTax / (100 + +el?.surchargePercent || 0)) *
        (+el?.surchargePercent || 0);
      beforeTax = (aftefTax / (100 + +el?.surchargePercent || 0)) * 100;
    } else {
      beforeTax = el?.currentFee * el?.quantity - el?.discount;

      tax = (beforeTax * (el?.surchargePercent || 0)) / 100;

      aftefTax = beforeTax + tax;
    }

    let remaining =
      aftefTax -
      (el?.currentAllocateDiscount || 0) -
      el?.subTotalBillPatientPaid; // con lai
    return remaining;
  };

  handleCreateVoucherAndUpdateToCrm = async (obj, { setSubmitting }) => {
    let { prepaidCards, products, services, treatmentCards } = obj;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];

    return createVoucherAndUpdateToCrm({ ...obj, invoiceItems })
      .then(async ({ data }) => {
        const urlParams = new URLSearchParams(window.location.search);
        const patientId = urlParams.get("patientId");
        this.getDataVoucherTotalCategory({ patientId });
        toast.success("Thanh toán thành công!");
        this.openInvoicePopup = false;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Thanh toán có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleUpdateVoucher = async (obj, { setSubmitting }) => {
    return updateVoucher({ ...obj })
      .then(async ({ data }) => {
        if (data?.responseStatus === false) {
          this.setOpenConfirmError(data);
          return;
        } else {
          toast.success("Cập nhật thành công!");
          this.openVoucherPopupDetail = false;
          this.getDataVoucherTotalCategory();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  setOpenConfirmError = (state) => {
    this.openConfirmError = state;
  };
  setInitialValuePopupFee = (data) => {
    let { prepaidCards, products, services, treatmentCards } = data;
    let totalAmount = 0;
    if (data.prepaidCards) {
      data.prepaidCards.items = prepaidCards?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);
        totalAmount += remaining;
        return {
          ...el,
          checked: true,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.products) {
      data.products.items = products?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);
        totalAmount += remaining;
        return {
          ...el,
          checked: true,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.services) {
      data.services.items = services?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);
        totalAmount += remaining;
        return {
          ...el,
          checked: true,
          currentPaymentAmount: remaining,
        };
      });
    }
    if (data.treatmentCards) {
      data.treatmentCards.items = treatmentCards?.items?.map((el) => {
        let remaining = this.handleCalculateRemaining(el);
        totalAmount += remaining;
        return {
          ...el,
          checked: true,
          currentPaymentAmount: remaining,
        };
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank
    if (
      !data?.voucherPaymentMethods ||
      data?.voucherPaymentMethods?.length === 0
    ) {
      voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
        return {
          paymentMethodValue: el,
          totalOfMethod:
            el?.characteristic ===
            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
              ? totalAmount
              : 0,

          note: "",
          paymentBank:
            el?.characteristic ===
            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
              ? this.listStk?.[0]
              : null,
        };
      });
    }

    return {
      ...data,
      voucherPaymentMethods,
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      paymentMethodSelect: true,
      totalAmount,
      percentDiscount: 0,
      discount: 0,
      moneyAfterDiscount: totalAmount,
    };
  };

  getDataInvoicePopupFee = async (obj) => {
    return await getInvoiceItemByType({ ...obj, incompletePaymentItems: true })
      .then(async ({ data }) => {
        let formatData = this.setInitialValuePopupFee({
          ...data,
          patient: obj?.patient,
        });
        this.dataInvoicePopupFee = formatData;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      });
  };

  handleReceiveAdvancePayment = (values, { setSubmitting }) => {
    return receiveAdvancePayment(values)
      .then(async ({ data }) => {
        this.openDepositPopup = false;
        toast.success("Lưu tiền cọc thành công");
        this.getDataVoucherTotalCategory();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  setOpenStaffRevenueUpdate = (state) => {
    this.openStaffRevenueUpdate = state;
  };

  createPaymentVoucherWithListMethod = async (values) => {
    return await createPaymentVoucherWithListMethod(values)
      .then(({ data }) => {
        toast.success("Tạo phiếu chi thành công");
        this.openPaymentVoucherPopup = false;
        this.getDataVoucherTotalCategory();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Tạo phiếu chi có lỗi");
      });
  };

  createReceiptVoucherWithListMethod = async (values) => {
    return await createReceiveVoucherWithListMethod(values)
      .then(({ data }) => {
        toast.success("Tạo phiếu thu thành công");
        this.openReceiptVoucherPopup = false;
        this.getDataVoucherTotalCategory();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Tạo phiếu thu có lỗi");
      });
  };

  initDataInvoiceUpdatePopup = async (obj) => {
    return await getDetailById(obj?.id)
      .then(async ({ data }) => {
        let { voucherPaymentMethods, voucherInvoiceType } = data;
        let isAdvance =
          VOUCHER_INVOICE_TYPE_VALUE.Advance === voucherInvoiceType;
        if (isAdvance) {
          voucherPaymentMethods = voucherPaymentMethods.filter(
            (el) =>
              el?.paymentMethodValue?.characteristic === null ||
              el?.paymentMethodValue?.characteristic ===
                PAYMENT_METHOD_CHARACTERISTIC[0].value
          );
        }

        if (voucherPaymentMethods?.length > 0) {
          const formatItems = await Promise.all(
            (voucherPaymentMethods || []).map(async (item) => {
              if (item?.bankAccountNumber) {
                let paymentBank = await pagingExtGlobalProperty({
                  keyword: item?.bankAccountNumber,
                  pageIndex: 1,
                  pageSize: 1,
                  isActive: true,
                });
                return {
                  ...item,
                  paymentBank: paymentBank?.data?.content?.[0],
                };
              } else {
                return item;
              }
            })
          );
          this.dataVoucherPopupFee = {
            ...data,
            voucherPaymentMethods: formatItems,
          };
        } else {
          this.dataVoucherPopupFee = data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      });
  };

  handleInitPaymentVoucherPopup = () => {
    let staffRevenues = [];

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank

    voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
      return {
        paymentMethodValue: el,
        totalOfMethod: 0,
        note: "",
        paymentBank:
          el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC[0].value
            ? this.listStk?.[0]
            : null,
      };
    });
    this.initialPaymentVoucher = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      voucherPaymentMethods,
    };
  };

  handleInitReceiptVoucherPopup = () => {
    let staffRevenues = [];

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank

    voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
      return {
        paymentMethodValue: el,
        totalOfMethod: 0,
        note: "",
        paymentBank:
          el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC[0].value
            ? this.listStk?.[0]
            : null,
      };
    });
    this.initialReceiptVoucher = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      voucherPaymentMethods,
    };
  };

  handleOpenPaymentVoucherPopup = () => {
    this.handleInitPaymentVoucherPopup();
    this.openPaymentVoucherPopup = true;
  };

  handleClosePaymentVoucherPopup = () => {
    this.openPaymentVoucherPopup = false;
    this.initialPaymentVoucher = null;
  };

  handleCloseReceiptVoucherPopup = () => {
    this.openReceiptVoucherPopup = false;
    this.initialReceiptVoucher = null;
  };

  setDataVoucherPopupFee = (obj) => {
    this.dataVoucherPopupFee = obj;
  };

  handleOpenServiceFeePopup = (voucher) => {
    let { patient } = voucher;
    this.openInvoicePopup = true;
    this.getDataInvoicePopupFee({ patient, patientId: patient?.id });
  };

  handleOpenServiceUpdate = (voucher) => {
    this.openVoucherPopupDetail = true;
    this.editableVoucher = true;
    if (voucher?.id) {
      this.initDataInvoiceUpdatePopup(voucher);
    }
  };
  handleCloseServiceFeePopup = () => {
    this.openInvoicePopup = false;
    this.openVoucherPopupDetail = false;
  };
  handleClosePrintPopup = () => {
    this.openPopupPrint = false;
  };
  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  getListPaymentMethod = async () => {
    return await pagingObj({ pageIndex: 1, pageSize: PAGESIZE_ALL })
      .then(({ data }) => {
        this.listPaymentMethod = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  getListProperties = async (obj) => {
    return await pagingExtGlobalProperty({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      isActive: true,
      ...obj,
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          const listStk = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_BANK
          );
          this.listStk = listStk;
          const listPos = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_LIST
          );
          this.listPos = listPos;

          const listPos_tragop = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP
          );
          this.listPos_tragop = listPos_tragop;

          const listHomecredit = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE
          );
          this.listHomecredit = listHomecredit;

          return {
            listStk,
            listPos,
            listPos_tragop,
            listHomecredit,
          };
        } else {
          return {
            listStk: [],
            listPos: [],
            listPos_tragop: [],
            listHomecredit: [],
          };
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  handleOpenPopupPrint = (state) => {
    this.openPopupPrint = state;
  };

  handleInitDeposit = (patient) => {
    let staffRevenues = [];
    if (patient?.currentConsultant) {
      staffRevenues.push({
        position: patient?.currentConsultant?.position,
        staff: patient?.currentConsultant,
        percentRevenue: 100,
      });
    }
    if (patient?.currentTelesale) {
      staffRevenues.push({
        position: patient?.currentTelesale?.position,
        staff: patient?.currentTelesale,
        percentRevenue: 100,
      });
    }

    let voucherPaymentMethods = []; // setup paymentMethod default money = method bank

    voucherPaymentMethods = this.listPaymentMethod?.map((el) => {
      return {
        paymentMethodValue: el,
        totalOfMethod: 0,
        note: "",
        paymentBank:
          el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC[0].value
            ? this.listStk?.[0]
            : null,
      };
    });
    this.initialDeposit = {
      voucherDate: new Date(),
      accountant: getCurrentStaff(),
      staffRevenues,
      patient,
      voucherPaymentMethods,
    };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteVoucher = async () => {
    return await cancelVoucherAndUpdateInvoice(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        toast.success("Xóa hóa đơn thành công");
        this.getDataVoucherTotalCategory();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa  hóa đơn có lỗi");
      });
  };
  pagingFeeCard = async (patientId) => {
    return await pagingTreatmentPlanCard({ ...this.searchFeeCard, patientId })
      .then(({ data }) => {
        this.pageCardFee = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleOpenDepositPopup = (patient) => {
    this.handleInitDeposit(patient);
    this.openDepositPopup = true;
  };

  handleCloseDepositPopup = () => {
    this.openDepositPopup = false;
  };

  handleOpenClientCardFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    await this.pagingFeeCard(patientId);
    this.listServiceFromFeePopupSelected = invoiceItems;
    let cardUsedValue =
      this.pageCardFee?.content?.length > 0 &&
      this.pageCardFee?.content?.reduce((acc, curr) => {
        return acc + curr?.totalValue * curr?.quantity - curr?.totalUsed;
      }, 0);
    this.listSelectedCard = this.pageCardFee?.content;
    this.listSelectedSv = invoiceItems;
    this.initialValueCardFee = {
      department,
      accountant,
      cardUsedValue,
      moneyAfterDiscount: values?.moneyAfterDiscount,
      dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
    };
    this.openClientCardFeePopup = true;
  };

  handleOpenDepositMoneyFeePopup = async (values) => {
    let {
      prepaidCards,
      products,
      services,
      treatmentCards,
      patientId,
      department,
      accountant,
    } = values;
    let invoiceItems = [
      ...(prepaidCards?.items?.filter((el) => el?.checked) || []),
      ...(products?.items?.filter((el) => el?.checked) || []),
      ...(services?.items?.filter((el) => el?.checked) || []),
      ...(treatmentCards?.items?.filter((el) => el?.checked) || []),
    ];
    try {
      let { data } = await getTotalUsedDeposit(patientId);
      this.listServiceFromFeePopupSelected = invoiceItems;
      this.listSelectedSv = invoiceItems;
      this.initialValueDepositMoneyFee = {
        department,
        accountant,
        moneyAfterDiscount: values?.moneyAfterDiscount,
        dataInitialValuePopupFee: values, // luu tạm dữ liệu popup cũ vào
        totalAdvanceAmount: data,
        patientId,
      };
      this.openDepositMoneyFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleInitCardItemsAndServiceItems = async (values) => {
    return await initPrepaidCardTransaction({
      cards: this.listSelectedCard,
      invoiceItems: this.listSelectedSv,
      accountant: values?.accountant,
      department: values?.department,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu phân bổ thẻ có lỗi");
      });
  };
  handleSubmitTransactionCard = (values) => {
    let { voucherPaymentMethods } = values?.dataInitialValuePopupFee;
    const totalOfMethodCard =
      values?.transItems?.length > 0 &&
      values?.transItems?.reduce((acc, curr) => {
        return acc + +curr?.amount;
      }, 0);
    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC[3].value
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodCard,
          detailTransaction: { transItems: values?.transItems },
        };
      }
      return { ...el, totalOfMethod: 0 };
    });
    this.openClientCardFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  handleInitAdvanceMoneyTransaction = async (values) => {
    return await initAdvanceMoneyTransaction({
      invoiceItems: this.listSelectedSv,
      accountant: values?.accountant,
      department: values?.department,
      totalAdvanceAmount: values?.totalAdvanceAmount,
      patientId: values?.patientId,
    })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu phân bổ tiền cọc có lỗi");
      });
  };

  handleSubmitTransactionDepositMoney = (values) => {
    let { voucherPaymentMethods, moneyAfterDiscount } =
      values?.dataInitialValuePopupFee;
    const totalOfMethodDeposit =
      values?.transItems?.length > 0 &&
      values?.transItems?.reduce((acc, curr) => {
        return acc + +curr?.amount;
      }, 0);

    let totalOfMethodCard = 0;

    voucherPaymentMethods = voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC[1].value
      ) {
        return {
          ...el,
          totalOfMethod: totalOfMethodDeposit,
          detailTransaction: { transItems: values?.transItems },
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC[3].value
      ) {
        totalOfMethodCard = el?.totalOfMethod;
        return {
          ...el,
        };
      } else if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC[0].value
      ) {
        return {
          ...el,
          totalOfMethod:
            moneyAfterDiscount - totalOfMethodDeposit - totalOfMethodCard,
        };
      }
      return { ...el, totalOfMethod: 0 };
    });
    this.openDepositMoneyFeePopup = false;
    this.dataInvoicePopupFee = {
      ...values?.dataInitialValuePopupFee,
      voucherPaymentMethods,
    };
  };

  handleOpenReceiptVoucherPopup = () => {
    this.handleInitReceiptVoucherPopup();
    this.openReceiptVoucherPopup = true;
  };

  handleCloseClientCardFeePopup = () => {
    this.openClientCardFeePopup = false;
    this.listSelectedSv = [];
    this.listSelectedCard = [];
  };

  handleCloseDepositMoneyFeePopup = () => {
    this.openDepositMoneyFeePopup = false;
    this.listSelectedSv = [];
    this.listSelectedCard = [];
  };
  resetStore = () => {
    this.searchVoucherFee = { ...DEFAULT_SEARCH_VOUCHER_FEE };
    this.dataVoucherFee = [];
    this.openConfirmMessage = null;
    this.openConfirmDelete = null;
    this.listPaymentMethod = [];
    this.listStk = [];
    this.editableVoucher = false;
    this.openConfirmError = null;
  };

  resetStorePopup = () => {
    this.dataInvoicePopupFee = null;
    this.editableVoucher = false;
  };
}
